import Vue from 'vue';
import * as Sentry from '@sentry/vue';

if (process.env.NODE_ENV === 'production')
{
	Sentry.init({
		Vue: Vue,
		dsn: 'https://1c48b60aff2646fa9ac1e191058a3a59@sentry.io/189653',
		release: process.env.COMMIT.trim(),
		environment: process.env.NODE_ENV
	});
}

// localStorage drop-in replacement fallback
import storage from 'local-storage-fallback';
if ( ! ('localStorage' in window)) window.localStorage = storage;

import Vue2Filters from 'vue2-filters';
import http from './plugins/http';
import Modal from './plugins/modal';
import Flash from './plugins/flash';
import Widget from './plugins/widget';
import Confirm from './plugins/confirm';
import Current from './plugins/current';
import ONDURO from './plugins/onduro';
import Notify from './plugins/notify';
import Loader from './plugins/loader';
import Tools from './plugins/tools';
import Notes from './plugins/notes';
import Tooltip from './plugins/tooltip';
import Chatbox from './plugins/chatbox';
import Calendar from './plugins/calendar';
import Timepicker from './plugins/timepicker';
import University from './plugins/university';
import i18n from 'vue-i18n';
import Validation from './plugins/validation';
import store from './vuex/store';
import './filters';
import localStore from './plugins/localStore';
import Vue2Dnd from './plugins/vue2-dnd';
import router from './router';
import wysiwyg from 'vue-wysiwyg';

window._ = require('lodash');
window.moment = require('moment');

Vue.use(Vue2Filters);
Vue.use(i18n);
Vue.use(http);
Vue.use(Modal);
Vue.use(Flash);
Vue.use(Widget);
Vue.use(Current);
Vue.use(Confirm);
Vue.use(ONDURO);
Vue.use(Notify);
Vue.use(Loader);
Vue.use(Validation);
Vue.use(Notes);
Vue.use(Tools);
Vue.use(Chatbox);
Vue.use(Calendar);
Vue.use(Timepicker);
Vue.use(University);
Vue.use(localStore);
Vue.use(Vue2Dnd);
Vue.use(Tooltip);

// https://github.com/chmln/vue-wysiwyg
Vue.use(wysiwyg, {
    hideModules: { 
        'code': true,
        'link': true,
        'separator': true,
    },
    forcePlainTextOnPaste: true
});

// try to login user and initialize current store
store.dispatch('auth/checkAuth');

// Load global components
import './components/globals';

// handler for missing translations
Vue.config.missingHandler = function(lang, key, vm) {
    if (process.env.NODE_ENV != 'production') console.info('missing translation', lang, key);
};

export {
    router,
    store
};



// WEBPACK FOOTER //
// ./src/js/bootstrap.js